import * as colorsLight from "../../tokens/js/light";

export default colorsLight;